/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';

import { OfferRuleModel } from '../model/offerRuleModel';
import { SmartDineResponseOfferRuleModel } from '../model/smartDineResponseOfferRuleModel';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class OfferRuleRestControllerService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createOfferRules(body: OfferRuleModel, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseOfferRuleModel>;
    public createOfferRules(body: OfferRuleModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseOfferRuleModel>>;
    public createOfferRules(body: OfferRuleModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseOfferRuleModel>>;
    public createOfferRules(body: OfferRuleModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createOfferRules.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseOfferRuleModel>('post',`${this.basePath}/api/admin/offerrules`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param offerRuleId 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOfferRule(offerRuleId: string, restaurantId: string, restaurantBranchId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseOfferRuleModel>;
    public deleteOfferRule(offerRuleId: string, restaurantId: string, restaurantBranchId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseOfferRuleModel>>;
    public deleteOfferRule(offerRuleId: string, restaurantId: string, restaurantBranchId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseOfferRuleModel>>;
    public deleteOfferRule(offerRuleId: string, restaurantId: string, restaurantBranchId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (offerRuleId === null || offerRuleId === undefined) {
            throw new Error('Required parameter offerRuleId was null or undefined when calling deleteOfferRule.');
        }

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling deleteOfferRule.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseOfferRuleModel>('delete',`${this.basePath}/api/admin/offerrules/${encodeURIComponent(String(offerRuleId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param offerRuleId 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOfferRule(offerRuleId: string, restaurantId: string, restaurantBranchId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseOfferRuleModel>;
    public getOfferRule(offerRuleId: string, restaurantId: string, restaurantBranchId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseOfferRuleModel>>;
    public getOfferRule(offerRuleId: string, restaurantId: string, restaurantBranchId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseOfferRuleModel>>;
    public getOfferRule(offerRuleId: string, restaurantId: string, restaurantBranchId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (offerRuleId === null || offerRuleId === undefined) {
            throw new Error('Required parameter offerRuleId was null or undefined when calling getOfferRule.');
        }

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling getOfferRule.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseOfferRuleModel>('get',`${this.basePath}/api/admin/offerrules/${encodeURIComponent(String(offerRuleId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOfferRules(restaurantId: string, restaurantBranchId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseOfferRuleModel>;
    public getOfferRules(restaurantId: string, restaurantBranchId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseOfferRuleModel>>;
    public getOfferRules(restaurantId: string, restaurantBranchId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseOfferRuleModel>>;
    public getOfferRules(restaurantId: string, restaurantBranchId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling getOfferRules.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseOfferRuleModel>('get',`${this.basePath}/api/admin/offerrules`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param offerRuleId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateOfferRule(body: OfferRuleModel, offerRuleId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseOfferRuleModel>;
    public updateOfferRule(body: OfferRuleModel, offerRuleId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseOfferRuleModel>>;
    public updateOfferRule(body: OfferRuleModel, offerRuleId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseOfferRuleModel>>;
    public updateOfferRule(body: OfferRuleModel, offerRuleId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateOfferRule.');
        }

        if (offerRuleId === null || offerRuleId === undefined) {
            throw new Error('Required parameter offerRuleId was null or undefined when calling updateOfferRule.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseOfferRuleModel>('put',`${this.basePath}/api/admin/offerrules/${encodeURIComponent(String(offerRuleId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
